<template>
  <div v-if="!authStore.authenticated && !simple" class="header">
    <a href="https://www.studentpop.fr/"><img src="/static/img/auth/logo-small.svg" alt="Student Pop"></a>
    <div class="line"/>
    <p>Bonjour,
      <strong>bienvenue sur votre espace client</strong>
    </p>
  </div>
  <div
    v-else-if="!simple"
    id="app-header"
    :class="{ checkout: checkout, template: ($route.name === 'co.v2.template' || $route.name === 'co.v2.chooseteam') }"
  >
    <div
      v-if="!isApp && (!checkout || $route.name === 'co.v2.template' || $route.name === 'co.v2.chooseteam')"
      class="logo-menu"
      @click="mobileSidebarToggle"
    >
      <span/><span/><span/>
    </div>
    <img
      :src="'/static/img/' + $brand.logo"
      alt="logo sp"
      class="logo"
      @click="backToHome"
    >
    <div class="line"/>
    <div class="steps">
      <div class="user-info">
        <div
          class="avatar"
          :style="{ backgroundImage: `url('${ currentUserAvatar }')` }"
        />
        <transition name="fade">
          <div class="helloworld hidden-sm">
            <div>
              Bonjour, <span v-if="accountStore.firstName" class="bold">{{ currentUserFirstName }}</span>
            </div>
          </div>
        </transition>
      </div>
      <SettingWheel v-if="!isApp"/>
      <ButtonTeam v-if="!isApp"/>

      <div
        v-if="(!checkout || $route.name === 'co.v2.template' || $route.name === 'co.v2.chooseteam') && !isApp"
        @click="goTo('quotes')"
      >
        <router-link
          v-if="customerOrderPlace ||customerOrderRequest"
          to="/quotes/to-validate"
          class="btn-quotes"
        >
          <div class="btn-quote" :class="{ inactive: isPendingQuote === 0 }">
            <div class="nb">{{ isPendingQuote }}</div>
            <div class="text hidden-xs">
              {{ $t('top_bar.quote_label', isPendingQuote) }}
            </div>
          </div>
        </router-link>
      </div>
      <CheckoutHeader v-if="checkout"/>
      <JobStats/>
    </div>
  </div>
  <div v-else id="app-header">
    <div
      v-if="$route.name === 'co.v2.template' || $route.name === 'co.v2.chooseteam'"
      class="logo-menu"
      @click="mobileSidebarToggle"
    >
      <span/><span/><span/>
    </div>
    <img
      src="/static/img/logo-sp.svg"
      alt="logo sp"
      class="logo"
      @click="backToHome"
    >
    <div class="line"/>
    <div class="user-info">
      <div
        class="avatar"
        :style="{ backgroundImage: `url('${ $route.query.companyLogo }')` }"
      />
    </div>
    <div v-if="$route.query.company" class="helloworld hidden-sm">
      Bienvenue dans la team&nbsp;<strong>{{ $route.query.company }}</strong>&nbsp;de {{ $brand.label }} !
    </div>
    <div v-else class="helloworld hidden-sm">
      Vous avez été invité à rejoindre une équipe sur {{ $brand.label }} !
    </div>
  </div>
</template>

<script>
import ButtonTeam from '@/components/Global/ButtonTeam';
import SettingWheel from '@/components/Global/SettingWheel';
import JobStats from '@/components/Global/JobStats';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useCompanyStore } from '@/stores/company';
import CheckoutHeader from './Header/CheckoutHeader';

export default {
  name: 'app-header',
  components: {
    CheckoutHeader,
    ButtonTeam,
    SettingWheel,
    JobStats,
  },
  props: ['simple', 'checkout'],
  data() {
    return {
      route: null,
    };
  },
  computed: {
    ...mapStores(useAccountStore, useAuthStore, useCompanyStore),
    isApp() {
      if (this.authStore.userAgent) {
        return this.authStore.userAgent.androidWebview || this.authStore.userAgent.iosWebview;
      }
      return false;
    },
    currentUserFirstName() {
      if (this.accountStore.firstName) {
        return this.accountStore.firstName;
      }
      return null;
    },
    currentUserAvatar() {
      if (this.accountStore.mainPicture && this.accountStore.mainPicture.format) {
        return this.accountStore.mainPicture.format.small;
      }
      return this.accountStore.mainPicture;
    },
    isPendingQuote() {
      return this.companyStore.quotesPending;
    },
    customerOrderPlace() {
      if (this.accountStore.permissions) {
        return this.accountStore.permissions.customerOrdersPlace;
      }
      return false;
    },
    customerOrderRequest() {
      if (this.accountStore.permissions) {
        return this.accountStore.permissions.customerOrdersRequest;
      }
      return false;
    },
  },
  watch: {
    $route() {
      document.body.classList.remove('sidebar-mobile-show');
      this.route = this.$route;
    },
  },
  mounted() {
    this.route = this.$route;
  },
  methods: {
    goTo(event) {
      if (event === 'team') {
        this.$mixpanel.track('My Pop Team Displayed');
        this.$router.push({ path: '/me/settings', query: { tab: this.$t('settings.fourth_tab.title') } });
      }

      if (event === 'profil') {
        this.$mixpanel.track('Profile Edit Displayed');
        this.$router.push({ path: '/me/settings' });
      }

      if (event === 'quotes') {
        this.$mixpanel.track('Demands Displayed');
      }
    },
    backToHome() {
      if (this.customerOrderPlace) {
        this.$router.push('/home');
      } else {
        this.$router.push('/job');
      }
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
  },
};
</script>
